(() => {
  function init(root) {
    root.querySelectorAll('[data-sor-page]').forEach(page => {
      if (page.dataset.sorReady) return;
      page.dataset.sorReady = 'true';
      const vehicle = page.querySelector('#sor-vehicle');
      const picker = page.querySelector('#sor-vehicle-picker');
      if (picker) picker.addEventListener('change', event => {
        vehicle.value = event.target.value === 'Other vehicle' ? '' : event.target.value;
      });
      page.querySelectorAll('[data-sor-category]').forEach(link => {
        link.addEventListener('click', () => {
          page.querySelector('#sor-category').value = link.dataset.sorCategory;
          page.querySelector('[data-sor-status]').textContent = `Selected: ${link.querySelector('h3').textContent}. Add your vehicle details and message below.`;
        });
      });
      if (document.documentElement.hasAttribute('data-sor-preview')) {
        page.querySelector('form').addEventListener('submit', event => {
          event.preventDefault();
          page.querySelector('[data-sor-status]').textContent = 'Preview only: nothing has been sent. The Shopify page uses the store contact form.';
        });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', () => init(document));
})();
